// #BACE60 -> #2B96D8
export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#092644',
    light: '#CECECE',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#DCE9F4',
    contrastText: '#092644',
    light: '#DCE9F4f9',
  },
  text: {
    primary: '#092644',
    secondary: '#4A5462',
    alternate: '#23B0E7',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#092644',
    paper: '#FFF',
    default: '#FFF',
    header: '#0D0D0D',
    footer: '#F7F7F7',
    level2: '#5D6D93',
    level1: '#4E7287',
    steps: '#000000',
    tableHead: '#092644',
    tableSubhead: '#F7F7F7',
    tableBorder: '#7D808880',
    tableAlternate: '#F8F8F8',
    alternate: '#d4f1f9',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#092644',
    secondary: '#9DCFF9',
    light: '#F7F7F7',
    secondaryLight: '#9DCFF9ee',
  },
  verticalBar: {
    used: '#092644',
    unused: '#CECECE',
    unlimited: '#C0C0C0',
  },
  primitives: {
    secondary: '#8BAF2F',
  },
};
